// extracted by mini-css-extract-plugin
module.exports = {"bigCardsListContainer":"BigCardInforResponsiveMobile_bigCardsListContainer__ZMQ45","scoreCardsItem":"BigCardInforResponsiveMobile_scoreCardsItem__D6-ne"};